export default function ServicesGrid() {
  return (
    <section className="py-24 bg-[#f2f4f6]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-[#00255a] mb-4">Study Abroad and Scholarship Support</h2>
          <p className="text-[#64748b] max-w-2xl mx-auto">
            Practical, end-to-end guidance for international university admissions, scholarship applications, visas and relocation.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2 bg-white p-8 rounded-2xl border border-[#e2e8f0] hover:shadow-xl hover:-translate-y-1 transition-all flex flex-col md:flex-row gap-8 items-center">
            <div className="flex-1">
              <div className="w-16 h-16 rounded-2xl bg-[#1e3c72]/10 flex items-center justify-center text-[#00255a] mb-6">
                <span className="material-symbols-outlined text-4xl">school</span>
              </div>
              <h3 className="text-xl font-semibold text-[#00255a] mb-4">University Admissions and Scholarships</h3>
              <p className="text-[#64748b] mb-6">Get end-to-end support finding eligible universities, affordable courses and scholarship opportunities for study abroad.</p>
              <a href="/courses" className="text-[#00255a] font-bold flex items-center gap-2 group">
                Explore Courses <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform">chevron_right</span>
              </a>
              <a href="/universities" className="text-[#00255a] font-bold flex items-center gap-2 group">
                Explore Universities <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform">chevron_right</span>
              </a>
            </div>
            <div className="flex-1 h-64 w-full rounded-xl overflow-hidden">
              <img className="w-full h-full object-cover" alt="University lecture hall" src="/images/university-lecture-hall.jpg" />
            </div>
          </div>

          <ServiceCard icon="work" title="International Job Placements" desc="Connect qualified professionals with in-demand overseas careers in Europe, North America and beyond." bg="bg-[#ffdad8]/50" iconColor="text-[#79161e]" />
          <ServiceCard icon="description" title="Student Visa Guidance" desc="Receive clear, careful administrative support for your student visa or work visa application." bg="bg-[#d8e2ff]/50" iconColor="text-[#365da3]" />
          <ServiceCard icon="flight" title="Relocation Support" desc="Prepare for life abroad with practical guidance on accommodation, banking and settling into your destination." bg="bg-[#1e3c72]/10" iconColor="text-[#00255a]" />
          <ServiceCard icon="translate" title="IELTS and Test Preparation" desc="Build confidence for IELTS, TOEFL and other English-language tests required for international admissions." bg="bg-[#e0e3e5]" iconColor="text-[#44474f]" />
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ icon, title, desc, bg, iconColor }/*: { icon: string; title: string; desc: string; bg: string; iconColor: string }*/) {
  return (
    <div className="bg-white p-8 rounded-2xl border border-[#e2e8f0] hover:shadow-xl hover:-translate-y-1 transition-all">
      <div className={`w-12 h-12 rounded-xl ${bg} flex items-center justify-center ${iconColor} mb-6`}>
        <span className="material-symbols-outlined">{icon}</span>
      </div>
      <h3 className="text-xl font-semibold text-[#00255a] mb-4">{title}</h3>
      <p className="text-[#64748b]">{desc}</p>
    </div>
  );
}
